<ic-list-search-bar [hasActiveFilters]="hasActiveFilters" [page]="pageOption" (searchChange)="search$.next($event)">
	<i
		class="action fa fa-tasks tasks-filter"
		data-test="residents-with-tasks-filter-button"
		[class.tasks-filter--state-toggled]="taskToggleValue"
		(click)="toggleTasks.emit()"
	>
	</i>
</ic-list-search-bar>

<patient-list
	scroll="patientList"
	[patients]="patients$ | async"
	[showTasksCompletedState]="taskToggleValue && (isSearchingSpecificPatient$ | async) === false"
	(selectedPatient)="details.emit($event)"
/>
